import React, { useState } from 'react';
import Papa from 'papaparse';

const EmailSender = () => {
  const [csvData, setCsvData] = useState([]);
  const [fromName, setFromName] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [smtpCount, setSmtpCount] = useState(10);
  const [status, setStatus] = useState('');

  const handleCsvUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (results) => {
        if (!results.data[0]?.email || !results.data[0]?.name) {
          return alert("CSV must include 'name' and 'email' columns.");
        }
        setCsvData(results.data);
      },
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!csvData.length) return alert('Please upload a CSV first.');

    setStatus('Sending...');

    try {
      const res = await fetch('/api/send', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          fromName,
          subject,
          message,
          smtpCount,
          recipients: csvData,
        }),
      });

      const data = await res.json();
      if (data.success) {
        setStatus(`Queued ${csvData.length} emails using ${smtpCount} SMTP(s).`);
        setFromName('');
        setSubject('');
        setMessage('');
        setCsvData([]);
      } else {
        setStatus('Sending failed: ' + data.error);
      }
    } catch (err) {
      console.error(err);
      setStatus('An error occurred.');
    }
  };

  return (
    <div style={{ maxWidth: 800, margin: '40px auto', padding: 20, border: '1px solid #ccc', borderRadius: 10 }}>
      <h2>Email Sender</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          placeholder="From Name"
          value={fromName}
          onChange={(e) => setFromName(e.target.value)}
          style={{ width: '100%', marginBottom: 10 }}
          required
        />
        <input
          type="text"
          placeholder="Subject"
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          style={{ width: '100%', marginBottom: 10 }}
          required
        />

        {/* Editor + Preview side by side */}
        <div style={{ display: 'flex', gap: 20, marginBottom: 10 }}>
          <textarea
            rows="12"
            placeholder="Message body (use {{name}} to personalize)"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            style={{ flex: 1, width: '100%' }}
            required
          />
          <div style={{
            flex: 1,
            border: '1px solid #ddd',
            borderRadius: 6,
            padding: 10,
            background: '#fafafa',
            maxHeight: 300,
            overflowY: 'auto'
          }}>
            <h4 style={{ marginTop: 0 }}>🖼️ Preview</h4>
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </div>
        </div>

        <input type="file" accept=".csv" onChange={handleCsvUpload} style={{ marginBottom: 10 }} />

        <div style={{ marginBottom: 10 }}>
          <label>SMTPs to use: </label>
          <input
            type="number"
            min="1"
            max="10"
            value={smtpCount}
            onChange={(e) => setSmtpCount(Number(e.target.value))}
            required
          />
        </div>

        <button type="submit">Send Emails</button>
      </form>

      {csvData.length > 0 && (
        <p style={{ marginTop: 10 }}>📁 {csvData.length} emails loaded from CSV</p>
      )}
      {status && <p style={{ marginTop: 20 }}><strong>{status}</strong></p>}
    </div>
  );
};

export default EmailSender;
